import React, { Component } from "react";
import {
  generateJVReport,
  doGenerateJVClosingBalance,
} from "../../services/reportService";

import BlockUi from "react-block-ui";
import auth from "../../services/authService";
import DatePicker from "react-datepicker";

import ReactToPrint from "react-to-print";
import "react-datepicker/dist/react-datepicker.css";
import NetBalance from "../common/netbalance";

class JVReport extends Component {
  state = {
    startDate: new Date(),
    endDate: new Date(),
    transactions: [],
    showSalaryForm: false,
    showError: false,
    salaries: [],
    netBalance: 0,
    openingBalance: 0,
    closingBalance: 0,
    reportDate: "",
  };

  handleChangeStartDate = (date) => {
    this.setState({
      startDate: date,
    });
  };

  handleChangeEndDate = (date) => {
    this.setState({
      endDate: date,
    });
  };

  generateClosingBalance = async () => {
    let netBalance = parseFloat(this.state.openingBalance).toFixed(2);

    try {
      for (const [index, transaction] of this.state.transactions.entries()) {
        transaction.credit > 0
          ? (netBalance =
              parseFloat(netBalance) - parseFloat(transaction.credit)).toFixed(
              2
            )
          : (netBalance =
              parseFloat(netBalance) + parseFloat(transaction.debit)).toFixed(
              2
            );
      }

      this.setState({ closingBalance: netBalance });

      var event = new Date(this.state.startDate);
      //event.setDate(event.getDate() + 1);
      let startDate = JSON.stringify(event);
      startDate = startDate.slice(1, 11);

      const verifyData = {
        balanceDate: startDate,
        closingBalance: parseFloat(netBalance).toFixed(2),
      };

      const res = await doGenerateJVClosingBalance(verifyData);
    } catch (ex) {
      if (ex.response && ex.response.status === 422) {
        const errors = { ...this.state.errors };

        if (ex.response.data.errors.name)
          errors.name = ex.response.data.errors.name;

        this.setState({ errors, blocking: false });
        //toast.warning("check validation errors.");
      }
    }
  };

  doSubmit = async () => {
    try {
      //const reportDate = (this.state.startDate).split(" ");
      var event = new Date(this.state.startDate);
      this.setState({
        reportDate:
          event.getDate() +
          "-" +
          (event.getMonth() + 1) +
          "-" +
          event.getFullYear(),
      });

      //event.setDate(event.getDate() + 1);
      let startDate = JSON.stringify(event);

      startDate = startDate.slice(1, 11);

      event = new Date(this.state.endDate);
      let endDate = JSON.stringify(event);
      endDate = endDate.slice(1, 11);

      this.setState({ blocking: true });

      const verifyData = {
        startDate: startDate,
        //endDate: endDate,
      };

      const res = await generateJVReport(verifyData);

      if (res.data.proceed === "no") {
        this.setState({
          showError: true,
          showSalaryForm: false,
          blocking: false,
        });
      } else {
        this.setState({
          showError: false,
          showSalaryForm: true,
          blocking: false,
          transactions: res.data.entries,
          openingBalance: res.data.balances.opening_balance,
          closingBalance: res.data.balances.closing_balance,
        });
      }
    } catch (ex) {
      if (ex.response && ex.response.status === 422) {
        const errors = { ...this.state.errors };

        if (ex.response.data.errors.name)
          errors.name = ex.response.data.errors.name;

        this.setState({ errors, blocking: false });
        //toast.warning("check validation errors.");
      }
    }
  };

  formatOpeningBalance = () => {
    let fBalance;
    let balance = this.state.openingBalance.toString();
    if (balance < 0) {
      fBalance = "(" + balance.replace("-", "") + ")";
      return fBalance;
    }
    return balance;
  };

  formatClosingBalance = () => {
    let fBalance;
    let balance = this.state.closingBalance.toString();
    if (balance < 0) {
      fBalance = "(" + balance.replace("-", "") + ")";
      return fBalance;
    }
    return balance;
  };

  render() {
    if (auth.getCurrentUser().role != "client") {
      return "Your are authorized to perform this action.";
    }
    const { transactions } = this.state;
    return (
      <BlockUi tag="div" blocking={this.state.blocking}>
        <h1 className="container__heading">General Ledger JV Account</h1>
        <div className="grid report-filters">
          <DatePicker
            selected={this.state.startDate}
            onChange={this.handleChangeStartDate}
            className="input"
          />
          <button className="btn btn--primary" onClick={this.doSubmit}>
            Submit
          </button>
        </div>

        <div
          className="scrap-report"
          style={{
            display: this.state.showSalaryForm == true ? "block" : "none",
          }}
        >
          <div className="scrap-report__print">
            <ReactToPrint
              trigger={() => <a href="#">Print this out!</a>}
              content={() => this.componentRef}
            />
          </div>

          <div className="scrap-report__ob">
            Opening Balance:
            <b>{this.formatOpeningBalance()}</b>
          </div>

          <NetBalance
            type="jv"
            transactions={transactions}
            opening_balance={this.state.openingBalance}
            report="General Ledger JV Report"
            reportDate={this.state.reportDate}
            ref={(el) => (this.componentRef = el)}
          />

          <div className="scrap-report__cb">
            {this.state.closingBalance != 0 ? (
              "Closing Balance: " + this.formatClosingBalance()
            ) : (
              <button
                className="btn btn--accent"
                onClick={this.generateClosingBalance}
              >
                Generate Closing Balance
              </button>
            )}
          </div>
        </div>
      </BlockUi>
    );
  }
}

export default JVReport;
